
const presentation = {
  key: '<span class="cleaver-key">',
  value: '<span class="cleaver-value">',
  string:'<span class="cleaver-string">',
}

export default data => {
  let lines = []

  const addLine = (depth, obj, line, path) => {
    let strPath = path.join('.')
      , jsonPath = strPath

    if (Array.isArray(obj) && obj.length && !obj.some(isPrimitive)) {
      // Clicked an array without primitives, so we really want to
      // search a path of all children
      jsonPath += '.*'
    }

    lines.push({
      depth,
      jsonPath,
      matchPath: strPath,
      path,
      html: `<span style="padding-left: ${depth}em" class="cleaver-code-line-contents">${line}</span>`
    })
  }

  const printValue = value => {
    let buf = presentation.value

    if (typeof value === 'string') {
      buf += `${presentation.string}"${value}"</span>`
    } else if (typeof value === 'undefined') {
      buf += 'undefined'
    } else if (value === null) {
      buf += 'null'
    } else {
      buf += value
    }
    return buf += '</span>'
  }

  const isPrimitive = value => {
    return !(typeof value === 'object' && value !== null || Array.isArray(value))
  }

  const printKey = key => {
    return `${presentation.key}"${key}"</span>: `
  }

  const getSyntax = data => {
    if (Array.isArray(data)) {
      return {open: '[', close: ']'}
    } else {
      return {open: '{', close: '}'}
    }
  }

  const print = (data, level, path, key, isLast = false) => {
    let syntax = getSyntax(data)
      , isArray = Array.isArray(data)
      , objects = isArray ? data : Object.keys(data) // Determine what we're looping over
      , open = (key ? printKey(key) : '') + syntax.open
      , openIdx = lines.length

    if (!objects.length) {
      // No objects, put the closing syntax on the same line
      open += syntax.close
      if (!isLast) {
        open += ','
      }
    }

    if (level) {
      // New level, add to the path
      path = [].concat(path, key || '*')
    }

    addLine(level, data, open, path)
    lines.at(-1).blockStart = openIdx

    if (!objects.length) {
      lines.at(-1).blockEnd = openIdx
      // Return early
      return
    }

    Object.entries(data).forEach(([key, value], index) => {
      let isLast = index === objects.length - 1

      if (typeof value === 'object' && value !== null) {
        print(value, level + 1, path, !isArray ? key : null, isLast)
      } else {
        // Showing a value
        let line = printValue(value)

        if (!isArray) {
          // Add the key before the value when showing key/value pairs
          line = `${printKey(key)}${line}`
        }

        if (!isLast) {
          // Need a comma
          line += ','
        }
        addLine(level + 1, data, line, path)
      }
    })

    let close = syntax.close
    if (!isLast) {
      close += ','
    }

    addLine(level, data, close, path)
    lines.at(openIdx).blockEnd = lines.length - 1
  }

  print(data, 0, ['$'], null, true)

  return lines
}
